var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('question-template',{attrs:{"name":"isWantToRegisterVat","info":_vm.info,"answer1NextPath":_vm.answer1NextPath,"answer2NextPath":_vm.answer2NextPath}})}
var staticRenderFns = []

export { render, staticRenderFns }